import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const DotNet = () => {
  return (
    <StartInterviewLayout type="dotnet"/>
  )
}

export default DotNet;